<script setup>
import BaseModal from "../../global-themed/BaseModal.vue";
import axios from "axios";
import SweetToast from "../../../SweetToast";
import {useMutation, useQueryClient} from "@tanstack/vue-query";
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";

const props = defineProps({
  apiKey: {
    required: true,
    type: Object,
  }
});

const emit = defineEmits(['close']);
const queryClient = useQueryClient()

const {mutate: deleteApiKey, isPending} = useMutation({
  mutationFn: async () => await axios.delete(`/ajax/v2/api-keys/${props.apiKey.id}`),
  onSuccess: () => {
    SweetToast.fire({
      icon: 'success',
      title: `The API Key ${props.apiKey.name} has been deleted.`,
    });

    queryClient.invalidateQueries({ queryKey: ['api-keys'] })
    emit('close')
  },
  onError: () => {
    SweetToast.fire({
      icon: 'error',
      title: 'There was an error deleting your API Key',
    });

    emit('close')
  },
})
</script>

<template>
  <Teleport to=".tailwind">
    <BaseModal @close="$emit('close')">
      <div>
        <h2 class="tw-text-2xl tw-text-center tw-font-bold">
          Delete API Key?
        </h2>

        <div class="tw-min-w-[500px]">
          <p class="tw-my-6 tw-text-center">
            Are you sure you wish to do this? This action cannot be undone.
          </p>
        </div>
        <div class="tw-mt-4">
          <div class="tw-w-full tw-flex tw-justify-center tw-gap-2 tw-m-0">
            <DefaultButton
              @click="$emit('close')"
            >
              No Thanks
            </DefaultButton>
            <DefaultButton
              variant="danger"
              :disabled="isPending"
              @click="deleteApiKey"
            >
              <svg-vue
                v-if="isPending"
                class="tw-h-4 tw-mr-2"
                icon="icons/loading"
              />
              {{ isPending ? 'Deleting' : 'Delete Key' }}
            </DefaultButton>
          </div>
        </div>
      </div>
    </BaseModal>
  </Teleport>
</template>

